var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShrink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#2691d0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.23 19.75a.28.28 0 0 1-.09-.2.29.29 0 0 1 .09-.21l3-3-1.27-1.25a.56.56 0 0 1-.17-.4.54.54 0 0 1 .17-.4.52.52 0 0 1 .4-.17h4a.58.58 0 0 1 .57.57v4a.52.52 0 0 1-.17.4.54.54 0 0 1-.4.17.56.56 0 0 1-.4-.17l-1.29-1.28-3 3a.29.29 0 0 1-.21.09.28.28 0 0 1-.2-.09zm6.89-6.44v-4a.54.54 0 0 1 .17-.4.54.54 0 0 1 .4-.17.56.56 0 0 1 .4.17l1.28 1.29 3-3a.28.28 0 0 1 .2-.09.29.29 0 0 1 .21.09l1 1a.29.29 0 0 1 .09.21.28.28 0 0 1-.09.2l-3 3 1.29 1.28a.57.57 0 0 1 0 .81.56.56 0 0 1-.4.17h-4a.58.58 0 0 1-.57-.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrink);
export default __webpack_public_path__ + "static/media/shrink.c48a4a40d762d8b11633f6807be07cdb.svg";
export { ForwardRef as ReactComponent };